import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import {
  Eye as FiEye,
  ArrowRightCircle as FiConvert,
  XCircle as FiReject,
  ChatDots as FiChat,
  ThreeDotsVertical as FiMoreVertical,
} from 'react-bootstrap-icons';
import type { ClientOrder } from '../../models/clientOrder';
import styles from '../quotations/Quotations.module.scss';

const popperConfig = {
  strategy: 'fixed' as const,
  modifiers: [
    { name: 'offset', options: { offset: [0, 4] } },
    {
      name: 'preventOverflow',
      options: { boundary: 'viewport', altBoundary: true, padding: 8 },
    },
  ],
};

export interface ClientOrderRowActionsProps {
  order: ClientOrder;
  layout?: 'table' | 'mobile';
  canWrite?: boolean;
  onView: (order: ClientOrder) => void;
  onConvert: (order: ClientOrder) => void;
  onReject: (order: ClientOrder) => void;
  onOpenChat?: (order: ClientOrder) => void;
}

const ClientOrderRowActions: React.FC<ClientOrderRowActionsProps> = ({
  order,
  layout = 'table',
  canWrite = true,
  onView,
  onConvert,
  onReject,
  onOpenChat,
}) => {
  const canConvert = canWrite && order.status === 'submitted';
  if (layout === 'mobile') {
    return (
      <div className={styles.actionsGroup}>
        <Button size="sm" variant="outline-primary" onClick={() => onView(order)}>
          Ver
        </Button>
        {canConvert ? (
          <Button size="sm" variant="success" onClick={() => onConvert(order)}>
            A venta
          </Button>
        ) : null}
        {canConvert ? (
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => onReject(order)}
          >
            Rechazar
          </Button>
        ) : null}
      </div>
    );
  }

  return (
    <Dropdown className={styles.actionsDropdown} align="end">
      <Dropdown.Toggle
        variant="outline-secondary"
        size="sm"
        id={`client-order-actions-${order.id}`}
        className="d-inline-flex align-items-center"
      >
        <FiMoreVertical />
      </Dropdown.Toggle>
      <Dropdown.Menu popperConfig={popperConfig} renderOnMount>
        <Dropdown.Item onClick={() => onView(order)}>
          <FiEye className="me-2" /> Ver
        </Dropdown.Item>
        {onOpenChat && order.conversationId ? (
          <Dropdown.Item onClick={() => onOpenChat(order)}>
            <FiChat className="me-2" /> Ver chat
          </Dropdown.Item>
        ) : null}
        {canConvert ? (
          <>
            <Dropdown.Item onClick={() => onConvert(order)}>
              <FiConvert className="me-2" /> Convertir a venta
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              className="text-danger"
              onClick={() => onReject(order)}
            >
              <FiReject className="me-2" /> Rechazar
            </Dropdown.Item>
          </>
        ) : null}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ClientOrderRowActions;
